import { AnalyticsControllerApi, CatalogActivityControllerApi, BannedItemsControllerApi, BusinessReportControllerApi, CommonSavedFilterControllerApi, Configuration, DashboardControllerApi, InactiveCleanupControllerApi, InventoryControllerApi, KeywordScanControllerApi, MarketplaceFilterSettingControllerApi, OrderControllerApi, OrderFlagControllerApi, ProductPoolControllerApi, ProductStagingControllerApi, ProductUpdateJobControllerApi, ProfitMarginControllerApi, PromotionControllerApi, PromotionPricingControllerApi, RestrictionCheckControllerApi, SavedFilterControllerApi, SearchControllerApi, SpapiAuthControllerApi, StorefrontScanControllerApi, SupportRequestControllerApi, UserControllerApi, UserMarketplaceControllerApi, UserMarketplacePricingRuleControllerApi, WarehouseCaseControllerApi, WarehouseCreditControllerApi, WarehouseInfoControllerApi, WarehouseControllerApi, WarehousePackageHoldControllerApi, WarehouseDispatchControllerApi, WarehousePurchaseControllerApi, } from './index.js';
import { AuthControllerApi } from './openapi/apis/AuthControllerApi.js';
const configuration = new Configuration({
    accessToken: () => localStorage.getItem('jwt_token') || '',
    basePath: '',
    middleware: [
        {
            post: async (context) => {
                if (context.response.status === 401) {
                    localStorage.removeItem('jwt_token');
                    window.location.href = '/login';
                }
                return context.response;
            },
        },
    ],
});
export const authControllerApi = new AuthControllerApi(configuration);
export const dashboardApi = new DashboardControllerApi(configuration);
export const storeFrontApi = new StorefrontScanControllerApi(configuration);
export const productPoolApi = new ProductPoolControllerApi(configuration);
export const savedFiltersApi = new SavedFilterControllerApi(configuration);
export const commonSavedFiltersApi = new CommonSavedFilterControllerApi(configuration);
export const keywordScanApi = new KeywordScanControllerApi(configuration);
export const marketplaceFilterSettingApi = new MarketplaceFilterSettingControllerApi(configuration);
export const searchApi = new SearchControllerApi(configuration);
export const restrictionCheckApi = new RestrictionCheckControllerApi(configuration);
export const profitMarginApi = new ProfitMarginControllerApi(configuration);
export const promotionApi = new PromotionControllerApi(configuration);
export const promotionPricingApi = new PromotionPricingControllerApi(configuration);
export const productStagingApi = new ProductStagingControllerApi(configuration);
export const userMarketplaceApi = new UserMarketplaceControllerApi(configuration);
export const userMarketplacePricingRuleApi = new UserMarketplacePricingRuleControllerApi(configuration);
export const userApi = new UserControllerApi(configuration);
export const spapiAuthApi = new SpapiAuthControllerApi(configuration);
export const supportRequestApi = new SupportRequestControllerApi(configuration);
export const bannedItemsApi = new BannedItemsControllerApi(configuration);
export const inventoryApi = new InventoryControllerApi(configuration);
export const businessReportApi = new BusinessReportControllerApi(configuration);
export const inactiveCleanupApi = new InactiveCleanupControllerApi(configuration);
export const orderApi = new OrderControllerApi(configuration);
export const orderFlagApi = new OrderFlagControllerApi(configuration);
export const analyticsApi = new AnalyticsControllerApi(configuration);
export const catalogActivityApi = new CatalogActivityControllerApi(configuration);
export const productUpdateJobApi = new ProductUpdateJobControllerApi(configuration);
export const warehouseApi = new WarehouseControllerApi(configuration);
export const warehousePurchaseApi = new WarehousePurchaseControllerApi(configuration);
export const warehousePackageHoldApi = new WarehousePackageHoldControllerApi(configuration);
export const warehouseDispatchApi = new WarehouseDispatchControllerApi(configuration);
export const warehouseCaseApi = new WarehouseCaseControllerApi(configuration);
export const warehouseInfoApi = new WarehouseInfoControllerApi(configuration);
export const warehouseCreditApi = new WarehouseCreditControllerApi(configuration);
